export default (theme) => ({
	button: {
		margin: theme.spacing.unit,
	},
	floatingActionButton: {
		position: 'fixed',
		bottom: '23px',
		right: '23px',
		color: '#fff',
	},
	main: {
		// margin: 24,
		// backgroundColor: '#fff',
		borderRadius: 35,
		padding: 30,
		position: 'relative',
		maxWidth: '100vw',
		[theme.breakpoints.down('sm')]: {
			margin: 0,
			padding: 12,
			height: '100%',
			borderRadius: 0,
		},
	},
	list: {
		// border: '1px solid grey',
		// borderRadius: 35,
		// overflow: 'hidden',
	},
	listItem: {
		// display: 'flex',
		alignItems: 'center',
		borderBottom: '1px solid grey',
		'&:last-child': {
			borderTop: 'none',
		},
		position: 'relative',
		border: '1px solid grey',
		backgroundColor: '#fff',
		[theme.breakpoints.down('sm')]: {
			padding: '19px 36px 0px 12px',
		},
	},
	singleListItem: {
		// display: 'flex',
		alignItems: 'center',
		// borderBottom: '1px solid grey',
		// '&:last-child': {
		//   borderBottom: 'none',
		// },
		position: 'relative',
		border: '1px solid grey',
		backgroundColor: '#fff',
		[theme.breakpoints.down('sm')]: {
			padding: '19px 36px 0px 12px',
		},
	},
	even: {
		backgroundColor: '#d5e6f8',
	},
	titleText: {
		marginBottom: 14,
		fontSize: 25,
		fontWeight: 'bold',
		color: '#014c94',
		[theme.breakpoints.down('sm')]: {
			fontSize: 19,
			// marginBottom: 12,
		},
	},
	labelText: {
		color: theme.palette.text.secondary,
		fontWeight: 'bold',
		display: 'flex',
		fontSize: 14,
		[theme.breakpoints.down('sm')]: {
			fontSize: 12,
			alignItems: 'flex-end',
		},
	},
	firstItem: {
		flexBasis: '25%',
		flexShrink: 0,
		paddingLeft: 20,
	},
	secondItem: {
		flexBasis: '33%',
		flexShrink: 0,
	},
	thirdItem: {
		flexBasis: '20%',
		flexShrink: 0,
	},
	listItemCell: {
		padding: '12px 0',
	},
	callForwardingNumber: {
		borderRadius: 35,
		border: 'solid #707070',
		borderWidth: 1,
		padding: 10,
		fontSize: 14,
		'&:focus': {
			outline: 'none',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: 12,
			width: 'calc(100% - 23px)',
			// maxWidth: '130px',
		},
		[theme.breakpoints.up('md')]: {
			minWidth: 250,
		},
	},
	phoneNumber: {
		whiteSpace: 'nowrap',
		marginRight: 20,
		marginLeft: 20,
		[theme.breakpoints.down('sm')]: {
			fontSize: 13,
		},
	},
	moreIcon: {
		position: 'absolute',
		right: 10,
		top: '50%',
		transform: 'translate(0, -50%)',
		[theme.breakpoints.down('sm')]: {
			right: 7,
		},
	},
	moreIconRoot: {
		padding: 5,
		[theme.breakpoints.down('sm')]: {
			padding: 0,
		},
	},
	leftIcon: {
		marginRight: theme.spacing.unit,
	},
	cancelButton: {
		[theme.breakpoints.up('md')]: {
			position: 'absolute',
			bottom: 25,
			right: 0,
		},
	},
	first: {
		borderTopRightRadius: 35,
		borderTopLeftRadius: 35,
	},
	last: {
		borderBottomRightRadius: 35,
		borderBottomLeftRadius: 35,
	},
	item: {
		display: 'inline-block',
		[theme.breakpoints.down('sm')]: {
			display: 'block',
		},
	},
	forwardingNumberSection: {
		marginRight: 20,
		marginTop: 17,
		[theme.breakpoints.down('sm')]: {
			marginLeft: 13,
			marginRight: 0,
		},
	},
	select: {
		// minWidth: 175,
		marginTop: 17,
		marginBottom: 12,
		marginLeft: 12,
		position: 'relative',
		[theme.breakpoints.up('md')]: {
			minWidth: 300,
		},
	},
})
